<div class="navBar">
  <div class="leftNav loginuser" *ngIf="catogory$ | async as navcom">
    <div *ngFor="let item of navcom?.children">
      <div *ngIf="item.title == 'Products'">
        <a
          class="product nav-bar-links pl-4"
          [class.active-menu]="isShowDivIf"
          (clickOutside)="closeMenu()"
          [exclude]="'div,.plpmenuHide'"
          (click)="navigateProducts()"
        >
        {{ 'navBarLinks.productNavOption' | cxTranslate }}

          <em *ngIf="!isShowDivIf" class="material-icons"
            >keyboard_arrow_down</em
          >
          <em *ngIf="isShowDivIf" class="material-icons">keyboard_arrow_up</em>
        </a>
        <app-plp-menu-bar
          class="demo-plp"
          *ngIf="isShowDivIf"
        ></app-plp-menu-bar>
      </div>
      <div *ngIf="item?.title != 'Products' && userType == 'current' && item?.url">
        <a
          class="product nav-bar-links"
          (click)="closeMenu()"
          [routerLink]="item?.url"
        >
          {{ item.title }}
        </a>
      </div>
      <!-- <div *ngIf="item?.title != 'Products' && item?.title != 'Sale! Excess Inventory' && item?.url">
        <a
          class="product nav-bar-links"
          (click)="closeMenu()"
          [routerLink]="item?.url"
        >
          {{ item.title }}
        </a>
      </div> -->
      <!-- Excess Inventory Sale-->
      <!-- <div *ngIf="item?.title == 'Sale! Excess Inventory' && userType == 'current' && item?.url">

        <a
          class="product nav-bar-links"
          (click)="closeMenu()"
          [href]="item?.url"
          target="_blank"
        ><em class="material-icons-outlined download">cloud_download</em>
        {{ 'navBarLinks.saleExcessInventory' | cxTranslate }}
        </a>
      </div> -->
    </div>
  </div>

  <div class="rightNav loginuser" *ngIf="rightNavData">
    <div *ngFor="let item of rightNavData; let i = index">
      <div>
        <div *ngIf="item.title && item.url">
          @if(item?.target){
            <a class="nav-bar-links" (click)="closeMenu()" [href]="item?.url" [target]="item?.target">
              {{ item.title }}
            </a>
          }
          @else{
            <a class="nav-bar-links" (click)="closeMenu()" [routerLink]="item?.url">
              {{ item.title }}
            </a>
          }
          
          <div class="linkPipe" *ngIf="i + 1 < rightNavData.length">|</div>
        </div>
      </div>
    </div>
    <div class="linkPipe" >|</div>
    <div class="language-link">
      <div class="language">
        <label><span class="material-icons lang">language</span></label>
        <ng-select class="custom-dropdown"
            [searchable]="false"
            [clearable]="false"
            [placeholder]="currentLanguage"
            [(ngModel)]="currentLanguage"
            (change)="onLanguageChange($event)"
          >
            <ng-option
            *ngFor="let language of itemsArr"
              [value]="language?.value"
            >
              {{ language?.label }}
            </ng-option>
          </ng-select>
      </div>

    </div>
  </div>
</div>
